import { Icon } from "semantic-ui-react";

import { SnoozeActionSelector } from "modules/AppointmentDetails/components/SnoozedItems/components/SnoozeActionSelector";

import type { Appointment, Intervention, Snooze } from "models";
import type { QuestionResult } from "models/QuestionResult";

export type SnoozeAttachments = {
  url: string;
  name: string;
  type: string;
};

type SnoozeActionsProps = {
  appointment: Appointment;
  snoozeItem: Snooze;
  intervention?: Intervention;
  attachments?: SnoozeAttachments[];
  questionResult?: QuestionResult;
  snoozedItems?: (QuestionResult | Intervention)[];
  toggleShowMedia?: () => void;
};

export const SnoozeActions = ({ snoozeItem, intervention, questionResult, appointment, attachments, snoozedItems, toggleShowMedia }: SnoozeActionsProps) => (
  <div className="snooze-action">
    <div className="status-container">
      {attachments && attachments.length > 0 && toggleShowMedia && (
        <div onClick={toggleShowMedia}>
          <Icon className="images grey pointer" size="small" />
          <p>
            <small>{attachments.length}</small>
          </p>
        </div>
      )}
      <SnoozeActionSelector
        snoozeItem={snoozeItem}
        appointment={appointment}
        attachments={attachments}
        snoozedItems={snoozedItems}
        intervention={intervention}
        questionResult={questionResult}
      />
    </div>
  </div>
);
